'use client';

import { token } from '@terra/ui-styled-system';
import { Badge } from '../../../components/badge';
import { useTranslations } from 'next-intl';

export const InternalNetworkCredentialOwnedBadge = () => {
  const t = useTranslations('designSystem.networkSettings.internalCredentials');

  return (
    <Badge
      size="sm"
      variant="fill"
      bg={token('colors.bg.accent.light')}
      color={token('colors.fg.accent.muted')}
    >
      {t('ownedBadge')}
    </Badge>
  );
};
